// A meeting's transcript: its shape and the plain-text helpers (no browser or sign-in code).

export interface MeetingTranscript {
  /** The chunks came back in their captured order, so `text` is the whole transcript. */
  ordered: boolean;
  text: string | null;
  /** Unordered chunks from the old store, each on its own. */
  excerpts: string[];
}

/** The transcript as plain text: the whole thing, or the excerpts with a line between them. */
export function transcriptText(t: MeetingTranscript): string {
  return t.ordered ? (t.text ?? '') : t.excerpts.join('\n\n— — —\n\n');
}

/** A file name from the meeting's title and date, e.g. "Pricing review 2026-10-21 transcript.txt". */
export function transcriptFileName(title: string, date: string | null, ext: string): string {
  const name = [title.trim() || 'Meeting', date ?? ''].filter(Boolean).join(' ').replace(/[\\/:*?"<>|]+/g, '-');
  return `${name} transcript.${ext}`;
}

/**
 * The transcript's lines that contain every word of `query`, any case, in
 * order. A blank query matches nothing (show the whole transcript instead).
 */
export function matchingLines(text: string, query: string): string[] {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return [];
  return text.split('\n').filter((line) => {
    const lower = line.toLowerCase();
    return line.trim() !== '' && words.every((word) => lower.includes(word));
  });
}
